import { SET_UNREAD_NOTIFICATION_NNUMBER } from '../types/unreadNotificationNumber';

export const setUnreadNotificationNumber = (id) => {
  return {
    type: SET_UNREAD_NOTIFICATION_NNUMBER,
    payload: id,
  };
};
